/**
 * Simple LRU Cache implementation
 */
export class LRUCache<K> {
  private readonly maxSize: number;
  private readonly cache: Map<K, boolean>;

  constructor(maxSize: number) {
    this.maxSize = maxSize;
    this.cache = new Map();
  }

  has(key: K): boolean {
    return this.cache.has(key);
  }

  add(key: K): void {
    if (this.cache.has(key)) {
      this.cache.delete(key);
    } else if (this.cache.size >= this.maxSize) {
      const firstKey = this.cache.keys().next().value;
      if (firstKey !== undefined) {
        this.cache.delete(firstKey);
      }
    }

    this.cache.set(key, true);
  }

  clear(): void {
    this.cache.clear();
  }

  get size(): number {
    return this.cache.size;
  }
}
